import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArztDatenResponse } from '../../api/client.service';
import { FormControl } from '@angular/forms';
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: ' san-tnzeingabe',
  templateUrl: './tnzeingabe.component.html',
  styleUrls: ['./tnzeingabe.component.scss'],
  standalone: false,
})
export class TNZEingabeComponent implements OnInit {
  @Input() state: ArztDatenResponse;
  @Input() tnzBeginn: FormControl;

  @Output() ready = new EventEmitter();
  @Output() zurueck = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  checkReady() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.tnzBeginn.valid && this.ready.emit();
  }

  protected readonly calendarIcon = faCalendarAlt;
}
